/* eslint-disable @typescript-eslint/no-explicit-any */
import * as bicycleService from './bicycle-funnel.service';
import * as familyCompositionService from './family-funnel.service';
import * as vehicleService from './vehicle-funnel.service';
import * as homeService from './home-funnel.service';
import * as petService from './pet-funnel.service';

type FunnelService<V> = {
    getStoredValue: (type?: string) => V;
    setStoredValue: (value: V, type?: string) => void;
    calculatePremium: (value: V, funnelUrl: string, type?: string) => void;
};

class FunnelDataService<V> {
    async getStoredValue(dataType: string): Promise<V> {
        const service = this.getServiceByType(dataType);
        return await service?.getStoredValue(dataType);
    }

    async setStoredValue(dataType: string, value: V) {
        const service = this.getServiceByType(dataType);
        await service?.setStoredValue(value, dataType);
    }

    async submitValue(dataType: string, value: V, funnelUrl: string) {
        const service = this.getServiceByType(dataType);
        await service?.calculatePremium(value, funnelUrl, dataType);
    }

    private getServiceByType(dataType: string): FunnelService<any> {
        switch (dataType) {
            case 'AUTO':
            case 'BROM':
            case 'CVAN':
            case 'MOTR':
                return vehicleService;

            case 'WOON':
                return homeService;

            case 'FIET':
                return bicycleService;

            case 'AANS':
            case 'ONGV':
            case 'RB':
            case 'REIS':
                return familyCompositionService;

            case 'DIER':
                return petService;

            default:
                return undefined;
        }
    }
}

const instance = new FunnelDataService();

export const getInstance = <V>() => instance as FunnelDataService<V>;
